import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getProductDetails = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PRODUCT_DETAILS.METHOD](APIConfig.GET_PRODUCT_DETAILS.URL(productId), payload);
}
const addProduct = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_NEW_PRODUCT.METHOD](APIConfig.ADD_NEW_PRODUCT.URL, payload);
}
const addAdditionalDetails = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_ADDITIONAL_DETAILS.METHOD](APIConfig.ADD_ADDITIONAL_DETAILS.URL(productId), payload);
}
const addProductImage = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_PRODUCT_IMAGE.METHOD](APIConfig.ADD_PRODUCT_IMAGE.URL(productId), payload);
}
const deleteProductImage = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_PRODUCT_IMAGE.METHOD](APIConfig.DELETE_PRODUCT_IMAGE.URL(productId), payload);
}
const toggleProductStatus = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_PRODUCT_STATUS.METHOD](APIConfig.TOGGLE_PRODUCT_STATUS.URL(productId), payload);
}
const editProduct = (productId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_PRODUCT.METHOD](APIConfig.EDIT_PRODUCT.URL(productId), payload);
}
const InventoryService = {
    getProductDetails,
    addProduct,
    addAdditionalDetails,
    addProductImage,
    deleteProductImage,
    toggleProductStatus,
    editProduct
}
export default InventoryService;
